import { mapKeysToCamelCase } from '@skytech/utils'

import { get } from '@/util/auth'

import { API_ROUTE_SHOP_COST_OBJECT_OFFBOARDING_LOCK, API_ROUTE_SHOP_SETUP } from './api-routes'
import assetLocationResources from './asset-locations'

type CostObjectOriginal = {
  id: number
  code: string
  name: string
  employee_no: string
  customer_id: number
  customer_country_id: number
  department_name: string
  department_code: string
  email: string
  department_id?: number
  country_id: number
  customer_has_leasing: 0 | 1
}

type OffboardingLockOriginal = {
  is_blocked: boolean
  message: string | null
}

const employeeResources = {
  getList: async (hasLocationsAccess: boolean) => {
    const shopSetup = await get<CostObjectOriginal[]>(API_ROUTE_SHOP_SETUP)
    const parsedShopSetup = mapKeysToCamelCase(shopSetup)
    const locations = hasLocationsAccess ? await assetLocationResources.getList() : []

    const userList = parsedShopSetup.map(co => ({
      id: co.id,
      name: co.name,
      code: co.code,
      email: co.email,
      departmentName: co.departmentName,
      departmentCode: co.departmentCode,
      employeeNo: co.employeeNo,
      customerId: co.customerId,
      isLocation: false,
      departmentId: co.departmentId,
      countryId: co.countryId,
      customerCountryId: co.customerCountryId,
      customerHasLeasing: Boolean(co.customerHasLeasing),
    }))
    const locationList = locations.map(location => ({
      id: location.id,
      name: location.name || '',
      code: location.code,
      departmentName: location.department.name,
      departmentCode: location.department.code,
      customerId: location.customer.id,
      customerAddressId: location.customerAddress?.id,
      isLocation: true,
      countryId: location.countryId,
      customerHasLeasing: location.customerHasLeasing,
    }))

    const employees: {
      id: number
      name: string
      code: string
      departmentName: string
      departmentCode: string
      customerId: number
      isLocation: boolean
      countryId: number
      customerCountryId?: number
      customerHasLeasing: boolean
      employeeNo?: string
      customerAddressId?: number
      departmentId?: number
      email?: string
    }[] = [...userList, ...locationList]

    return { employees, userList, locationList }
  },
  getOffboardingLock: async (costObjectId: number) => {
    const response = await get<OffboardingLockOriginal>(
      API_ROUTE_SHOP_COST_OBJECT_OFFBOARDING_LOCK.replace(':costObjectId', String(costObjectId))
    )

    return mapKeysToCamelCase(response)
  },
}

export default employeeResources

export type Employee = Awaited<ReturnType<typeof employeeResources.getList>>['employees'][number]
export type ShopSetup = Awaited<ReturnType<typeof employeeResources.getList>>
